export type SlackUserMentionData = {
    readonly slack_user_id: string;
    readonly display_name: string;
};

export const EMPTY_SLACK_MENTION_MAP = new Map<string, string>();

const SLACK_USER_MENTION_PATTERN = /<@([UW][A-Z0-9]+)(?:\|([^>]+))?>/g;

function escapeMarkdownText(text: string): string {
    return text.replace(/([\\`*_{}[\]()#+.!|>-])/g, '\\$1');
}

function formatSlackUserMention(
    slackUserId: string,
    fallbackLabel: string | undefined,
    slackMentionMap: ReadonlyMap<string, string>,
): string {
    const resolvedDisplayName = slackMentionMap.get(slackUserId)?.trim();
    const fallbackDisplayName = fallbackLabel?.trim();
    return `@${resolvedDisplayName || fallbackDisplayName || 'Slack user'}`;
}

export function getSlackUserMentionsFromEvent(event: {
    readonly slack_user_mentions?: Array<SlackUserMentionData> | null;
}): Array<SlackUserMentionData> | undefined {
    const slackUserMentions = event.slack_user_mentions;
    return slackUserMentions && slackUserMentions.length > 0
        ? slackUserMentions
        : undefined;
}

export function buildSlackMentionMap(
    slackUserMentions?: Array<SlackUserMentionData>,
): ReadonlyMap<string, string> {
    return new Map(
        (slackUserMentions ?? []).map((mention) => [
            mention.slack_user_id,
            mention.display_name,
        ]),
    );
}

export function processSlackUserMentions(
    content: string,
    slackMentionMap: ReadonlyMap<string, string>,
): string {
    return content.replace(
        SLACK_USER_MENTION_PATTERN,
        (_match, slackUserId: string, fallbackLabel: string | undefined) =>
            formatSlackUserMention(slackUserId, fallbackLabel, slackMentionMap),
    );
}

export function processSlackUserMentionsForMarkdown(
    content: string,
    slackMentionMap: ReadonlyMap<string, string>,
): string {
    return content.replace(
        SLACK_USER_MENTION_PATTERN,
        (_match, slackUserId: string, fallbackLabel: string | undefined) =>
            escapeMarkdownText(
                formatSlackUserMention(
                    slackUserId,
                    fallbackLabel,
                    slackMentionMap,
                ),
            ),
    );
}
